
<template>
  <div>
    <apexchart type="line" :options="chartOptions" :series="series" width="100%" height="350"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
name: 'LineChart',
components: {
    apexchart: VueApexCharts
},
props: {
    series: {
        type: Array,
        required: true
    },
    categories: {
        type: Array,
        required: true // Ahora es obligatorio
    },
    labels: {
        type: Array,
        default: () => []
    },
    colors: {
        type: Array,
        default: () => ['#ad88f1']
    },
},
computed: {
    chartOptions() {
        return {
            chart: {
                height: 350,
                type: 'line',
            },
            xaxis: {
                categories: this.categories
            },
            grid: {
                row: {
                    colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'straight'
            },
            colors: this.colors,
        }
    }
},
}
</script>